module.exports = __webpack_public_path__ + "img/img-fish-error.png";